import { START_LOADING,END_LOADING, FETCH, CREATE,UPDATE, DELETE , ACTION, FETCH_ALL,  SET_ERROR, CLEAR_ERROR, GET_ERROR, FETCH_BY_ID, RESET, UPDATE_MULTIPART, USER_SUBSCRIPTION} from '../constants/actionTypes';

const initialState = {
    userSubscription:[],
    userSubscriptions:[],
    isLoading: false,
    error: null
};

// const userSubscriptionReducer = (state = initialState,action) =>{
//     if(action?.payload?.type === USER_SUBSCRIPTION ){
//         switch (action.type){
//             case GET_ERROR:
//                 return {...state,error: null};
//             case CLEAR_ERROR:
//                 return { ...state, error: null};
//             case SET_ERROR:
//                 return { ...state,  error: action.payload.error};
//             case START_LOADING:
//                 return {...state, isLoading:true}
//             case END_LOADING:
//                 return {...state, isLoading:false};
//             case FETCH: 
//                 return {...state, userSubscription: action.payload.data, loggedInSubscription:action.payload.loggedInSubscription };
//             case FETCH_ALL: 
//                 return {...state, userSubscriptions: action.payload.data};
//             case FETCH_BY_ID: 
//                 return {...state, userSubscription: action.payload.data};      
//             case CREATE:
//                 return { ...state, userSubscription: [...state.userSubscription?.subscriptions, action.payload], loggedInSubscription:action.payload?.loggedInSubscription };
//             case UPDATE:
//                 return {...state, userSubscription: state.userSubscription?.subscriptions._id === action.payload.data._id ? { ...state.userSubscription?.subscriptions, ...action.payload.data } : state.userSubscription?.subscriptions,  loggedInSubscription:action.payload?.loggedInSubscription };
//             case UPDATE_MULTIPART:
//                 return {...state, userSubscription: state.userSubscription?.subscriptions._id === action.payload.data._id ? { ...state.userSubscription?.subscriptions, ...action.payload.data } : state.userSubscription?.subscriptions,  loggedInSubscription:action.payload?.loggedInSubscription };
//             case DELETE:
//                 return {...state, userSubscription: state.userSubscription?.subscriptions?.map((userSubscription) => userSubscription._id !== action.payload.data?._id),  loggedInSubscription:action.payload?.loggedInSubscription };
//             case ACTION:
//                 return {...state, userSubscription:  action.payload.data,  loggedInSubscription:action.payload?.loggedInSubscription};
//             case RESET:
//                 return initialState;
//             default:
//                 return state;
//             }
//     }
//     else{
//         return state;
//     }
// };



const userSubscriptionReducer = (state = initialState, action) => {
  if (action?.payload?.type === USER_SUBSCRIPTION) {

    console.log('Action received in userSubscriptionReducer:', action);
    switch (action.type) {
      case GET_ERROR:
        return { ...state, error: null };
        
      case CLEAR_ERROR:
        return { ...state, error: null };
        
      case SET_ERROR:
        return { ...state, error: action.payload.error };
        
      case START_LOADING:
        return { ...state, isLoading: true };
        
      case END_LOADING:
        return { ...state, isLoading: false };
        
      case FETCH:
        return {
          ...state,
          userSubscription: action.payload.data,
          loggedInSubscription: action.payload.loggedInSubscription,
        };
        
      case FETCH_ALL:
        return { ...state, userSubscriptions: action.payload.data };
        
      case FETCH_BY_ID:
        return { ...state, userSubscription: action.payload.data };
        
      case CREATE:
        return {
          ...state,
          userSubscription: {
            ...state.userSubscription,
            subscriptions: [
              ...(state.userSubscription?.subscriptions || []),
              action.payload,
            ],
          },
          loggedInSubscription: action.payload?.loggedInSubscription,
        };
        
      case UPDATE:
        return {
          ...state,
          userSubscription: {
            ...state.userSubscription,
            subscriptions: state.userSubscription?.subscriptions?.map((sub) =>
              sub._id === action.payload.data._id ? { ...sub, ...action.payload.data } : sub
            ),
          },
          loggedInSubscription: action.payload?.loggedInSubscription,
        };
        
      case UPDATE_MULTIPART:
        return {
          ...state,
          userSubscription: {
            ...state.userSubscription,
            subscriptions: state.userSubscription?.subscriptions?.map((sub) =>
              sub._id === action.payload.data._id ? { ...sub, ...action.payload.data } : sub
            ),
          },
          loggedInSubscription: action.payload?.loggedInSubscription,
        };
        
      case DELETE:
        return {
          ...state,
          userSubscription: {
            ...state.userSubscription,
            subscriptions: state.userSubscription?.subscriptions?.filter(
              (sub) => sub._id !== action.payload.data?._id
            ),
          },
          loggedInSubscription: action.payload?.loggedInSubscription,
        };
        
      case ACTION:
        return {
          ...state,
          userSubscription: action.payload.data,
          loggedInSubscription: action.payload?.loggedInSubscription,
        };
        
      case RESET:
        return initialState;
        
      default:
        return state;
    }
  } else {
    return state;
  }
};

export default userSubscriptionReducer;